@if (template === "type1") {
  <div>
    @if (contact) {
      <div class="profile">
        <div class="picture-container">
          <app-avatar
            [name]="contact.firstName + ' ' + contact.lastName"
            [userId]="contact.userId"
            [width]="150"
            [height]="150"
            [hasImage]="!!contact.profilePic"
            [picUrl]="contact.profilePic"
            [badgeMargin]="'5'"
            [badgeBorder]="'4'"
          >
          </app-avatar>
          <div class="name celo-elipsis-2">
            <div class="text">
              {{ contact.title }} {{ contact.firstName }} {{ contact.lastName }}
            </div>
            <div class="badge-icon">
              &nbsp;<app-badge
                class="inline-block"
                [identityVerificationStatus]="
                  contact.identityVerificationStatus
                "
                [workspaces]="contact.workplaces"
                [profession]="contact.professions[0]"
                [size]="26"
                [showTooltip]="false"
                [clickable]="true"
                [title]="contact.title"
                [name]="contact.firstName + ' ' + contact.lastName"
                [name_verified_as]="
                  contact.legalFirstName + ' ' + contact.lastName
                "
                [userId]="contact.userId"
                [hasImage]="!!contact.profilePic"
              ></app-badge>
            </div>
          </div>
          @if (contact.professions && contact.professions[0]) {
            <div class="subname celo-elipsis-2">
              <div class="text">
                {{ contact.professions[0].profession }}
                @if (
                  contact.professions[0].verificationStatus === "Unverified"
                ) {
                  <span>(Unverified)</span>
                }
              </div>
            </div>
          }
          @if (dndUntil && dndUntil > now) {
            <div>
              <div class="dnd-status appear_2">
                <img
                  class="svgIcon"
                  src="../../assets/icons/icon-dnd-v2.svg"
                  alt=""
                />
                <div class="dnd-text celo-elipsis">Do not disturb</div>
              </div>
            </div>
          }
          @if (contact["blockedByMe"] && contact["blockedByMe"].isBlocked) {
            <div class="appear_2 blocked-text">
              You’ve blocked {{ contact.title }} {{ contact.firstName }}
              {{ contact.lastName }}. You can unblock this user to send them a
              message.
            </div>
          }
          @if (
            contact["blockedMe"] &&
            contact["blockedMe"].isBlocked &&
            !(contact["blockedByMe"] && contact["blockedByMe"].isBlocked)
          ) {
            <div class="appear_2 blocked-text">
              This user is unavailable to contact on Celo.
              <a class="celo-link" (click)="userUnavailableDialog()"
                >Learn more.</a
              >
            </div>
          }
        </div>
        @if (
          (!contact["blockedByMe"] || !contact["blockedByMe"].isBlocked) &&
          (!contact["blockedMe"] || !contact["blockedMe"].isBlocked)
        ) {
          <div class="profile-buttons">
            @if (!isCurrentUser) {
              <div
                class="button"
                [ngClass]="{ fw: !showSecureMessageButton() }"
              >
                @if (
                  !contact["connection"] ||
                  !contact["connection"].state ||
                  contact["connection"].state === "Disconnected" ||
                  contact["connection"].state === "Rejected"
                ) {
                  <button
                    mat-button
                    class="celo-primary-button"
                    (click)="connect()"
                  >
                    <div class="button-content pending-connect-button">
                      <span>Connect</span>
                    </div>
                  </button>
                }
                @if (
                  contact["connection"] &&
                  contact["connection"].state === "Accepted"
                ) {
                  <button
                    mat-button
                    class="celo-secondary-button"
                    [matMenuTriggerFor]="menu"
                  >
                    <div class="button-content">
                      <span>Connected</span>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                  </button>
                }
                <mat-menu #menu="matMenu" class="remove-text">
                  <button
                    (click)="removeConnection(contact['connection'])"
                    mat-menu-item
                    class="remove-text"
                  >
                    Remove Connection
                  </button>
                </mat-menu>
                @if (
                  contact["connection"] &&
                  contact["connection"].state === "Pending"
                ) {
                  <div>
                    @if (
                      contact["connection"]["createdBy"] === contact.userId
                    ) {
                      <button
                        mat-button
                        (click)="acceptConnection(contact['connection'])"
                        class="celo-primary-button"
                      >
                        <div class="button-content">
                          <span>Accept connection</span>
                        </div>
                      </button>
                    }
                    @if (
                      contact["connection"]["createdBy"] !== contact.userId
                    ) {
                      <button mat-button disabled class="celo-primary-button">
                        <div class="button-content pending-connect-button">
                          <span>Pending</span>
                        </div>
                      </button>
                    }
                  </div>
                }
              </div>
            }
            @if (showSecureMessageButton()) {
              <div class="button" [style.width]="isCurrentUser ? '100%' : null">
                <button
                  (click)="secureMessage()"
                  mat-button
                  class="celo-primary-button"
                >
                  <div class="button-content">
                    <span>Secure Message</span>
                  </div>
                </button>
              </div>
            }
          </div>
        }
        @if (
          (!contact["connection"] ||
            contact["connection"].state !== "Accepted") &&
          !hasCommanWorkspace &&
          companiesLoaded &&
          !(contact["blockedByMe"] && contact["blockedByMe"].isBlocked) &&
          !(contact["blockedMe"] && contact["blockedMe"].isBlocked)
        ) {
          <div class="no-network">Connect with this user to contact them.</div>
        }
        <div class="profile-info">
          <div class="profile-title">Personal Info</div>
          @if (contact.firstName) {
            <div class="field appear_1">
              <div class="celo-field-title">Preferred Name</div>
              <div class="celo-text-14">{{ contact.firstName }}</div>
            </div>
          }
          <div class="field appear_2">
            <div class="celo-field-title">Full Name</div>
            <div class="celo-text-14 celo-break-word flex items-center">
              {{ contact.legalFirstName }} {{ contact.lastName }}
              @if (contact.identityVerificationStatus === "Verified") {
                <app-badge
                  class="inline-block badge"
                  [identityVerificationStatus]="
                    contact.identityVerificationStatus
                  "
                  [profession]="contact.professions[0]"
                  [doNotShowProfessionVerificationStatus]="true"
                  [workspaces]="contact.workplaces"
                  [size]="20"
                  [showTooltip]="false"
                  [clickable]="true"
                  [name]="contact.firstName + ' ' + contact.lastName"
                  [name_verified_as]="
                    contact.legalFirstName + ' ' + contact.lastName
                  "
                  [title]="contact.title"
                  [userId]="contact.userId"
                  [hasImage]="!!contact.profilePic"
                ></app-badge>
              }
            </div>
          </div>
          @if (contact.professions[0] && contact.professions[0].category) {
            <div class="field appear_2">
              <div class="celo-field-title">Profession</div>
              <div class="celo-text-14 flex items-center">
                <span>{{ contact.professions[0].profession }}</span>
                @if (contact.professions[0].verificationStatus === "Verified") {
                  <div class="badge" (click)="$event.stopPropagation()">
                    <app-badge
                      [identityVerificationStatus]="'Verified'"
                      [profession]="contact.professions[0]"
                      [workspaces]="contact.workplaces"
                      [size]="20"
                      [showTooltip]="false"
                      [clickable]="true"
                      [ownProfile]="false"
                      [name]="contact.firstName + ' ' + contact.lastName"
                      [name_verified_as]="
                        contact.legalFirstName + ' ' + contact.lastName
                      "
                      [title]="contact.title"
                      [userId]="contact.userId"
                      [hasImage]="!!contact.profilePic"
                    ></app-badge>
                  </div>
                }
                @if (
                  contact.professions[0].verificationStatus === "Unverified"
                ) {
                  <span class="subtext">(Unverified)</span>
                }
              </div>
            </div>
          }
        </div>
        @if (contact.phoneNumber || contact.email) {
          <div class="profile-info">
            <div class="profile-title">Contact Info</div>
            <div class="profile-info-contents">
              @if (contact.phoneNumber) {
                <div mat-ripple class="celo-hoverable field">
                  <a [href]="'tel:' + contact.phoneNumber">
                    <div class="celo-field-title">Mobile Number</div>
                    <div class="celo-text-14">{{ contact.phoneNumber }}</div>
                  </a>
                </div>
              }
              @if (contact.email) {
                <div mat-ripple class="celo-hoverable field">
                  <a [href]="'mailto:' + contact.email">
                    <div class="celo-field-title">Primary Email</div>
                    <div class="celo-text-14">{{ contact.email }}</div>
                  </a>
                </div>
              }
            </div>
          </div>
        }
        <div class="profile-info">
          <div class="profile-title">Workspace Info</div>
          <div class="profile-info-contents">
            @for (company of companies; track company) {
              <div mat-ripple>
                @if (company.companyName && company.isActive !== false) {
                  <div class="celo-hoverable company-info celo-break-word">
                    <app-info-line
                      [title]="company.companyName"
                      [subtitles]="[
                        company.position,
                        company.departmentName
                          ? company.departmentName
                          : 'No department',
                        company.email,
                      ]"
                      [showBadge]="true"
                      [workspaces]="[company]"
                    ></app-info-line>
                  </div>
                }
              </div>
            }
            @if (!companies || !companies.length) {
              <div class="no-workspace">No workspaces</div>
            }
          </div>
        </div>
        @if (!isCurrentUser) {
          <div>
            <button
              mat-button
              class="block-button"
              (click)="onBlockStatusChange(contact.userId)"
            >
              @if (
                !contact["blockedByMe"] || !contact["blockedByMe"].isBlocked
              ) {
                <span>Block</span>
              }
              @if (contact["blockedByMe"] && contact["blockedByMe"].isBlocked) {
                <span>Unblock</span>
              }
            </button>
          </div>
        }
      </div>
    }
    @if (loading && !contact) {
      <div>
        <app-empty-state [isLoading]="true"></app-empty-state>
      </div>
    }
  </div>
}
@if (template === "type2") {
  <div class="type-2">
    @if (contact) {
      <div class="profile">
        <div class="outlet-content">
          <div class="network-header header">
            <div class="network-cover">
              <div class="cover">
                <div class="cover-background">
                  <div class="cover-image"></div>
                </div>
              </div>
            </div>
            <div class="logo">
              @if (!false) {
                <div class="icon">
                  <app-avatar
                    [name]="contact.firstName + ' ' + contact.lastName"
                    [userId]="contact.userId"
                    [width]="120"
                    [height]="120"
                    [hasImage]="!!contact.profilePic"
                    [picUrl]="contact.profilePic"
                    [badgeMargin]="'5'"
                    [badgeBorder]="'4'"
                  >
                  </app-avatar>
                </div>
              }
            </div>
            <div class="network-header-content">
              <div class="flex">
                <div class="title">
                  {{ contact.title }} {{ contact.firstName }}
                  {{ contact.lastName }}
                </div>
                <div class="badge-icon">
                  &nbsp;<app-badge
                    class="inline-block"
                    [identityVerificationStatus]="
                      contact.identityVerificationStatus
                    "
                    [workspaces]="contact.workplaces"
                    [profession]="contact.professions[0]"
                    [size]="26"
                    [showTooltip]="false"
                    [clickable]="true"
                    [title]="contact.title"
                    [name]="contact.firstName + ' ' + contact.lastName"
                    [name_verified_as]="
                      contact.legalFirstName + ' ' + contact.lastName
                    "
                    [userId]="contact.userId"
                    [hasImage]="!!contact.profilePic"
                  ></app-badge>
                </div>
              </div>
              @if (contact.professions && contact.professions[0]) {
                <div class="subtitle">
                  {{ contact.professions[0].profession }}
                  @if (
                    contact.professions[0].verificationStatus === "Unverified"
                  ) {
                    <span>(Unverified)</span>
                  }
                </div>
              }
              @if (dndUntil && dndUntil > now) {
                <div>
                  <div class="dnd-status appear_2">
                    <img
                      class="svgIcon"
                      src="../../assets/icons/icon-dnd-v2.svg"
                      alt=""
                    />
                    <div class="dnd-text celo-elipsis">Do not disturb</div>
                  </div>
                </div>
              }
              @if (contact["blockedByMe"] && contact["blockedByMe"].isBlocked) {
                <div class="appear_2 blocked-text">
                  You’ve blocked {{ contact.title }} {{ contact.firstName }}
                  {{ contact.lastName }}. You can unblock this user to send them
                  a message.
                </div>
              }
              @if (
                contact["blockedMe"] &&
                contact["blockedMe"].isBlocked &&
                !(contact["blockedByMe"] && contact["blockedByMe"].isBlocked)
              ) {
                <div class="appear_2 blocked-text">
                  This user is unavailable to contact on Celo.
                  <a class="celo-link" (click)="userUnavailableDialog()"
                    >Learn more.</a
                  >
                </div>
              }
              <div class="flex">
                @if (
                  (!contact["connection"] ||
                    contact["connection"].state !== "Accepted") &&
                  !hasCommanWorkspace &&
                  companiesLoaded &&
                  !(
                    contact["blockedByMe"] && contact["blockedByMe"].isBlocked
                  ) &&
                  !(contact["blockedMe"] && contact["blockedMe"].isBlocked)
                ) {
                  <div class="no-network">
                    Connect with this user to contact them.
                  </div>
                }
                @if (
                  (!contact["blockedByMe"] ||
                    !contact["blockedByMe"].isBlocked) &&
                  (!contact["blockedMe"] || !contact["blockedMe"].isBlocked)
                ) {
                  <div class="profile-buttons network-buttons">
                    @if (!isCurrentUser) {
                      <div
                        class="button"
                        [ngClass]="{ fw: !showSecureMessageButton() }"
                      >
                        @if (
                          !contact["connection"] ||
                          !contact["connection"].state ||
                          contact["connection"].state === "Disconnected" ||
                          contact["connection"].state === "Rejected"
                        ) {
                          <button
                            mat-button
                            class="celo-primary-button"
                            (click)="connect()"
                          >
                            <div class="button-content pending-connect-button">
                              <span>Connect</span>
                            </div>
                          </button>
                        }
                        @if (
                          contact["connection"] &&
                          contact["connection"].state === "Accepted"
                        ) {
                          <button
                            mat-button
                            class="celo-secondary-button"
                            [matMenuTriggerFor]="menu"
                          >
                            <div class="button-content">
                              <span>Connected</span>
                              <i class="material-icons">keyboard_arrow_down</i>
                            </div>
                          </button>
                        }
                        <mat-menu #menu="matMenu" class="remove-text">
                          <button
                            (click)="removeConnection(contact['connection'])"
                            mat-menu-item
                            class="remove-text"
                          >
                            Remove Connection
                          </button>
                        </mat-menu>
                        @if (
                          contact["connection"] &&
                          contact["connection"].state === "Pending"
                        ) {
                          <div>
                            @if (
                              contact["connection"]["createdBy"] ===
                              contact.userId
                            ) {
                              <button
                                mat-button
                                (click)="
                                  acceptConnection(contact['connection'])
                                "
                                class="celo-primary-button"
                              >
                                <div class="button-content">
                                  <span>Accept connection</span>
                                </div>
                              </button>
                            }
                            @if (
                              contact["connection"]["createdBy"] !==
                              contact.userId
                            ) {
                              <button
                                mat-button
                                disabled
                                class="celo-primary-button"
                              >
                                <div
                                  class="button-content pending-connect-button"
                                >
                                  <span>Pending</span>
                                </div>
                              </button>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (showSecureMessageButton()) {
                      <div class="button">
                        <button
                          (click)="secureMessage()"
                          mat-button
                          class="celo-primary-button"
                        >
                          <div class="button-content">
                            <span>Secure Message</span>
                          </div>
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div>
            <div class="flex">
              <div class="profile-box">
                <div
                  class="profile-info profile-box-content profile-box-content-left"
                >
                  <div class="profile-title">Personal Info</div>
                  @if (contact.firstName) {
                    <div class="field appear_1">
                      <div class="celo-field-title">Preferred Name</div>
                      <div class="celo-text-14">{{ contact.firstName }}</div>
                    </div>
                  }
                  <div class="field appear_2">
                    <div class="celo-field-title">Full Name</div>
                    <div class="celo-text-14 celo-break-word flex items-center">
                      {{ contact.legalFirstName }} {{ contact.lastName }}
                      @if (contact.identityVerificationStatus === "Verified") {
                        <app-badge
                          class="inline-block"
                          [identityVerificationStatus]="
                            contact.identityVerificationStatus
                          "
                          [profession]="contact.professions[0]"
                          [doNotShowProfessionVerificationStatus]="true"
                          [workspaces]="contact.workplaces"
                          [size]="20"
                          [showTooltip]="false"
                          [clickable]="true"
                          [name]="contact.firstName + ' ' + contact.lastName"
                          [name_verified_as]="
                            contact.legalFirstName + ' ' + contact.lastName
                          "
                          [title]="contact.title"
                          [userId]="contact.userId"
                          [hasImage]="!!contact.profilePic"
                        ></app-badge>
                      }
                    </div>
                  </div>
                  @if (
                    contact.professions[0] && contact.professions[0].category
                  ) {
                    <div class="field appear_2">
                      <div class="celo-field-title">Profession</div>
                      <div class="celo-text-14">
                        <span>{{ contact.professions[0].profession }}</span>
                        @if (
                          contact.professions[0].verificationStatus ===
                          "Verified"
                        ) {
                          <div class="badge" (click)="$event.stopPropagation()">
                            <app-badge
                              [identityVerificationStatus]="'Verified'"
                              [profession]="contact.professions[0]"
                              [workspaces]="contact.workplaces"
                              [size]="20"
                              [showTooltip]="false"
                              [clickable]="true"
                              [ownProfile]="false"
                              [name]="
                                contact.firstName + ' ' + contact.lastName
                              "
                              [name_verified_as]="
                                contact.legalFirstName + ' ' + contact.lastName
                              "
                              [title]="contact.title"
                              [userId]="contact.userId"
                              [hasImage]="!!contact.profilePic"
                            ></app-badge>
                          </div>
                        }
                        @if (
                          contact.professions[0].verificationStatus ===
                          "Unverified"
                        ) {
                          <span class="subtext">(Unverified)</span>
                        }
                      </div>
                    </div>
                  }
                </div>
                @if (contact.phoneNumber || contact.email) {
                  <div
                    class="profile-info profile-box-content profile-box-content-left"
                  >
                    <div class="profile-title">Contact Info</div>
                    <div class="profile-info-contents">
                      @if (contact.phoneNumber) {
                        <div mat-ripple class="celo-hoverable field">
                          <a [href]="'tel:' + contact.phoneNumber">
                            <div class="celo-field-title">Mobile Number</div>
                            <div class="celo-text-14">
                              {{ contact.phoneNumber }}
                            </div>
                          </a>
                        </div>
                      }
                      @if (contact.email) {
                        <div mat-ripple class="celo-hoverable field">
                          <a [href]="'mailto:' + contact.email">
                            <div class="celo-field-title">Primary Email</div>
                            <div class="celo-text-14">{{ contact.email }}</div>
                          </a>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (!isCurrentUser) {
                  <div>
                    <button
                      mat-button
                      class="block-button"
                      (click)="onBlockStatusChange(contact.userId)"
                    >
                      @if (
                        !contact["blockedByMe"] ||
                        !contact["blockedByMe"].isBlocked
                      ) {
                        <span>Block</span>
                      }
                      @if (
                        contact["blockedByMe"] &&
                        contact["blockedByMe"].isBlocked
                      ) {
                        <span>Unblock</span>
                      }
                    </button>
                  </div>
                }
              </div>
              <div class="profile-box">
                <div
                  class="profile-info profile-box-content profile-box-content-right"
                >
                  <div class="profile-title">Workspace Info</div>
                  <div class="profile-info-contents">
                    @for (company of companies; track company) {
                      <div mat-ripple>
                        @if (
                          company.companyName && company.isActive !== false
                        ) {
                          <div
                            class="celo-hoverable company-info celo-break-word"
                          >
                            <app-info-line
                              [title]="company.companyName"
                              [subtitles]="[
                                company.position,
                                company.departmentName
                                  ? company.departmentName
                                  : 'No department',
                                company.email,
                              ]"
                              [showBadge]="true"
                              [workspaces]="[company]"
                            ></app-info-line>
                          </div>
                        }
                      </div>
                    }
                    @if (!companies || !companies.length) {
                      <div class="no-workspace">No workspaces</div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (loading && !contact) {
      <div>
        <app-empty-state [isLoading]="true"></app-empty-state>
      </div>
    }
  </div>
}
